import { ModalProps } from '@pypestream/design-system';
import { useCallback, useRef } from 'react';

export const useGenericModal = () => {
  const modalRef = useRef<ModalProps>(null);

  const openModal = useCallback(() => {
    if (modalRef?.current) {
      modalRef.current.open = true;
    }
  }, []);

  const closeModal = useCallback(() => {
    if (modalRef?.current) {
      modalRef.current.open = false;
    }
  }, []);

  return { modalRef, openModal, closeModal };
};
